module.exports = __webpack_public_path__ + "img/deezer.e05e7a8e.svg";